
/**
 * Utility to manage runtime phone for Sentry error tracking.
 * Uses localStorage.
 */

export const getTrustedPhone = (): string | null => {
    return localStorage.getItem('clero_trusted_phone');
};

export const setTrustedPhone = (phone: string | null) => {
    if (phone) {
        localStorage.setItem('clero_trusted_phone', phone);
    } else {
        localStorage.removeItem('clero_trusted_phone');
    }
};
